import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { baseUrl } from '@cloudsuite/mosaic-shared/scripts/base-url.js'

export const OUTLET_STOCK_API = Symbol('OUTLET_STOCK_API')

export class GetOutletStockRequest {
  method = 'GET' as const
  headers: HeadersInit = { Accept: 'application/json' }
  productId: number
  outletId: number

  constructor(productId: number, outletId: number) {
    this.productId = productId
    this.outletId = outletId
  }
}

export type OutletStockResponse = {
  stock: number
}

export interface OutletStockApi {
  getStock(request: GetOutletStockRequest): Promise<unknown>
}

@registerDependency(FAKE, OUTLET_STOCK_API)
export class FakeOutletStockApi implements OutletStockApi {
  requests: GetOutletStockRequest[] = []
  stockByOutletId: Map<number, number> = new Map()
  defaultStock = 0

  getStock(request: GetOutletStockRequest): Promise<unknown> {
    this.requests.push(request)
    const stock = this.stockByOutletId.get(request.outletId) ?? this.defaultStock
    return Promise.resolve({ stock })
  }
}

@registerDependency(REAL, OUTLET_STOCK_API)
export class RealOutletStockApi implements OutletStockApi {
  async getStock(request: GetOutletStockRequest): Promise<unknown> {
    const endpointUrl = new URL(`xhr/product/${request.productId}/outlet/${request.outletId}/stock`, await baseUrl())
    const response = await fetch(endpointUrl, {
      method: request.method,
      headers: request.headers,
    })

    if (!response.ok) {
      throw new Error(`Failed to fetch outlet stock (${response.status}): ${endpointUrl}`)
    }

    return await response.json()
  }
}
